import { useEconomyMode } from '@/contexts/EconomyModeContext';
import { AlertTriangle, RefreshCw } from 'lucide-react';
import { Button } from '@/components/ui/button';

export function EconomyModeBanner() {
  const { isEconomyMode, forceRefresh } = useEconomyMode();

  if (!isEconomyMode) return null;

  return (
    <div className="bg-warning/10 border-b border-warning/40 px-4 py-2 flex items-center justify-between gap-3">
      <div className="flex items-center gap-2 text-sm text-warning">
        <AlertTriangle className="h-4 w-4 flex-shrink-0" />
        <span>Atualização automática pausada para estabilidade</span>
      </div>
      <Button
        size="sm"
        variant="outline"
        className="h-7 text-xs border-warning text-warning hover:bg-warning/15"
        onClick={forceRefresh}
      >
        <RefreshCw className="h-3 w-3 mr-1" />
        Atualizar agora
      </Button>
    </div>
  );
}
